import { useQuery as s } from "react-query";
import { useEnvironment as a } from "../../../common/hooks/environment/useEnvironment.js";
import { getAdapter as u } from "../../adapter.js";
import { KioskConfigurationAdapter as c } from "../../models/kiosk/configuration/kioskConfiguration.adapter.js";
function p(r) {
  const {
    backendBaseUrl: n
  } = a();
  return s(
    "kiosk-landing",
    async ({
      signal: t
    }) => {
      const i = new URL(`${n}/configuration/kiosk-domain/?kiosk_id=${r}`), o = await fetch(i, {
        signal: t
      });
      if (o.status !== 200)
        throw new Error("Error");
      const e = await o.json();
      return u(c).adapt(e);
    },
    {
      refetchOnWindowFocus: !1
    }
  );
}
export {
  p as useKioskConfiguration
};
//# sourceMappingURL=useKioskConfiguration.js.map
